import { FormOutlined } from '@ant-design/icons';
import { Card, Divider, Timeline, Typography, Tooltip } from 'antd';
import parse, { Element, HTMLReactParserOptions } from 'html-react-parser';
import moment from 'moment';
import React from 'react';
import { Trans } from 'react-i18next';

import { CandidateCommentaryCollection, UserCollection } from '../../types';
import { getFrontendManualTranslations } from '../../utils';
import styles from './ApplicantHistory.module.css';

interface ApplicantAnnotationTimelineProps {
  annotationType?: CandidateCommentaryCollection['type'];
  annotation: string;
  fromStage?: string;
  opportunityTitle?: string;
  recruiterName: string;
  createdDate: string;
  users?: UserCollection[];
  enableChangeLanguage: boolean;
}

const ApplicantAnnotationTimeline = ({
  annotation,
  annotationType = 'NEUTRAL',
  fromStage,
  opportunityTitle,
  recruiterName,
  createdDate,
  users,
  enableChangeLanguage,
}: ApplicantAnnotationTimelineProps) => {
  const iconColor =
    annotationType === 'NEGATIVE'
      ? styles.errorColor
      : annotationType === 'POSITIVE'
      ? styles.sucessColor
      : styles.neutralColor;

  const processedAnnotation = React.useMemo(() => {
    const options: HTMLReactParserOptions = {
      replace: (domNode) => {
        if (
          domNode instanceof Element &&
          domNode.attribs &&
          domNode.attribs.class &&
          domNode.attribs.class.includes('mention') &&
          domNode.attribs['data-id']
        ) {
          const userId = Number(domNode.attribs['data-id'] || '');
          const user = users?.find(({ id }) => id === userId);

          if (user) {
            return (
              <Tooltip title={user.email}>
                <span data-id={user.id} className="mention">
                  @{user.full_name}
                </span>
              </Tooltip>
            );
          }
          return <></>;
        }
      },
    };

    return parse(annotation, options);
  }, [annotation, users]);

  return (
    <Timeline.Item dot={<FormOutlined className={iconColor} />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text strong>{recruiterName} </Typography.Text>
          <Trans>criou um comentário</Trans>
          {annotationType === 'NEGATIVE' && (
            <Typography.Text strong>
              {' '}
              <Trans>negativo</Trans>{' '}
            </Typography.Text>
          )}
          {annotationType === 'POSITIVE' && (
            <Typography.Text strong>
              {' '}
              <Trans>positivo</Trans>{' '}
            </Typography.Text>
          )}
          {annotationType === 'NEUTRAL' && (
            <Typography.Text strong>
              {' '}
              <Trans>neutro</Trans>{' '}
            </Typography.Text>
          )}
          {fromStage && opportunityTitle && (
            <>
              <Trans>na etapa</Trans>
              <Typography.Text strong>
                {' '}
                {getFrontendManualTranslations(fromStage, enableChangeLanguage)}{' '}
              </Typography.Text>
              <Trans>na vaga</Trans> <Typography.Text strong> {opportunityTitle}</Typography.Text>
            </>
          )}
        </Typography.Paragraph>
        <Divider />
        <div className={styles.description}>{processedAnnotation}</div>
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantAnnotationTimeline;
